<template>
  <div>
    <b-modal
      id="modal-search"
      ref="modal-search"
      title="Bookmark this Search"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
    >
      <b-alert v-model="title_check" variant="danger" dismissible>
        Title cannot be empty.
      </b-alert>
      <b-form-input
        v-model="savedSearch.title"
        :disabled="searchCreated"
        placeholder="Enter bookmark title"
      ></b-form-input>
      <br />
      <b-form-textarea
        id="snippet_description"
        v-model="savedSearch.description"
        :disabled="searchCreated"
        placeholder="Add your notes..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <div class="modal-footer">
        <b-button
          v-show="!searchCreated"
          class="mt-2 footer-btn"
          variant="secondary"
          @click="cancelCreate"
          >Close</b-button
        >
        <b-button
          v-show="!searchCreated"
          class="mt-2 footer-btn"
          variant="primary"
          @click="confirmModal"
          >Add Bookmark
        </b-button>
      </div>
      <div v-if="searchCreated" id="success">
        <b-alert variant="success" show
          >Successfully bookmarked this search.</b-alert
        >
        <div class="text-right">
          <b-button class="mt-2" variant="primary" @click="confirmCreate"
            >Close</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SaveSearch',
  data() {
    return {
      savedSearch: {
        title: '',
        description: '',
      },
      selected: null,
      searchCreated: false,
      updateTitle: 'Select Project',
      title_check: false,
    };
  },
  computed: {
    ...mapGetters(['projects', 'project', 'modal']),
  },
  methods: {
    resetSavedSearch() {
      this.savedSearch = {
        title: '',
        description: '',
      };
      this.title_check = false;
    },
    confirmCreate() {
      this.$refs['modal-search'].hide();
      this.searchCreated = false;
      this.resetSavedSearch();
    },
    cancelCreate() {
      this.$refs['modal-search'].hide();
      this.resetSavedSearch();
    },
    confirmModal() {
      if (!this.savedSearch.title) {
        this.title_check = true;
        return;
      }
      this.title_check = false;
      this.$store.dispatch('SAVE_SEARCH', {
        projectID: this.project.id,
        title: this.savedSearch.title,
        description: this.savedSearch.description,
        filters: this.modal.filters,
        query: this.modal.query,
        mode: this.modal.mode,
        actionDateStart: this.modal.actionDateStart,
        actionDateEnd: this.modal.actionDateEnd,
        offset: this.modal.searchOffset,
        prevNumPages: this.modal.prevNumPages,
      });
      this.searchCreated = true;
    },
  },
};
</script>
<style scoped>
.modal-footer {
  display: flex;
  justify-content: space-between;
}
.footer-btn {
  width: 40% !important;
}
</style>
